module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-instructions-for-use@2x.7f737309.jpg";